import script from "./SafeRichContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SafeRichContent.vue?vue&type=script&setup=true&lang=ts"

import "./SafeRichContent.vue?vue&type=style&index=0&id=321f4aa1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-321f4aa1"]])

export default __exports__